import { CustomerForm } from "@/components/customers/customerForm/CustomerForm";
import { CustomersTableMeta } from "@/components/customers/Customers";
import { customersRepository } from "@/database/repositories/customersRepository";
import { CustomerWithContacts } from "@/database/schema";
import { db } from "@/main";
import { ConfirmDelete } from "@/shared/confirmDelete/ConfirmDelete";
import { useClickOutside } from "@/utils";
import { Row, Table } from "@tanstack/react-table"
import { ArchiveRestore, MoreHorizontal, UserPen } from "lucide-react"
import { useRef, useState } from "react";
import { CSSTransition } from "react-transition-group";

interface DataTableRowActionsProps<TData> {
    row: Row<CustomerWithContacts>
    table: Table<TData>
}

export function CustomersTableRowActions<TData>({
    row,
    table
}: DataTableRowActionsProps<TData>) {
    const { openOptionsId, setOpenOptionsId, archiveCustomer, updateCustomer, setCustomers } = table.options.meta as CustomersTableMeta;
    const areaRef = useRef(null);

    const [isArchiveOpen, setIsArchiveOpen] = useState(false);
    const [isEditOpen, setIsEditOpen] = useState(false);

    useClickOutside(areaRef, () => {
        if (row.id === openOptionsId) setOpenOptionsId(null);
    }, "row-actions__trigger-button");

    return (
        <div className="row-actions">
            <div className="row-actions__container" >
                <button className="row-actions__trigger-button" onClick={() => {
                    if (openOptionsId === row.id) setOpenOptionsId(null);
                    else setOpenOptionsId(row.id);
                }}>
                    <MoreHorizontal width={18} height={18} />
                </button>
                <CSSTransition in={row.id === openOptionsId}
                    timeout={200}
                    classNames="fade"
                    exit={false}
                    unmountOnExit>
                    <div className={`row-actions__options`} ref={areaRef}>
                        <ul className="row-actions__options-list">
                            <li className="row-actions__option">
                                <button className="row-actions__option-button" onClick={() => {
                                    setIsEditOpen(true);
                                    setOpenOptionsId(null);
                                }}>
                                    <UserPen width={16} height={16} />
                                    <p>Edit</p>
                                </button>
                            </li>

                            <li className="row-actions__option">
                                <button className="row-actions__option-button row-actions__warning" onClick={() => {
                                    setIsArchiveOpen(true);
                                    setOpenOptionsId(null);
                                }}>
                                    <ArchiveRestore width={16} height={16} />
                                    <p>Archive</p>
                                </button>
                            </li>
                        </ul>
                    </div>
                </CSSTransition>
            </div>

            {isArchiveOpen && <div className="overlay">
                <ConfirmDelete
                    type="Customer"
                    action="Archive"
                    id={row.original.name}
                    onClose={() => setIsArchiveOpen(false)}
                    onDelete={async () => {
                        const { id, archivedContacts, activeContacts } = row.original;
                        await archiveCustomer(id, archivedContacts, activeContacts);
                    }}
                />
            </div>}
            {isEditOpen && <div className="overlay">
                <CustomerForm
                    customer={row.original as CustomerWithContacts}
                    title="Edit customer"
                    close={() => {
                        customersRepository.getAllWithContacts(db).then((res) => {
                            setCustomers(res);
                        });
                        setIsEditOpen(false)
                    }}
                    action={updateCustomer}
                />
            </div>}
        </div >
    )
}